export const getFees = (state) => state.fees